
import React from 'react'

import Get from './get'

import Post from './post'


React.Component.prototype.Get = Get
React.Component.prototype.Post = Post

function wrapResponse(res){
    return res.then((resp) => resp.data.data)
}

export { Get, Post, wrapResponse };